import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * for this page
 */

const createMarkup = function createMarkup(src) {
    return {
        __html: `<iframe width="764" height="223" scrolling="no" frameborder="no" border="0" style="border:0px; margin:0px;padding:0px;" src="${src}"></iframe>`,
    };
};

class Capital extends React.PureComponent {
    /**
     * 渲染组件
     */

    render() {
        const src = 'https://ifeng.szfiu.com/dynamic.html#/hk-summary';

        return <div className={styles.capital} dangerouslySetInnerHTML={createMarkup(src)} />;
    }
}

export default errorBoundary(Capital);
